export default "__VITE_ASSET__99e814f6__"